/*
 * Floating contact buttons.
 *
 * Replaces the two handlers in js/acciones.js: `toggleContactMenu`, which flipped a class
 * on the container from a click listener on an <a>, and `scrollToTop`.
 *
 * The state now lives on the toggle's `aria-expanded`, so the button announces itself, and
 * closing on Escape or on a click outside is what makes it usable without a mouse — the
 * original could only be closed by clicking the toggle again.
 */
class LbContactFab extends HTMLElement {
  connectedCallback() {
    this.group = this.querySelector('.lb-fab');
    this.toggle = this.querySelector('[data-lb-fab-toggle]');
    this.scrollTopButton = this.querySelector('[data-lb-fab-top]');

    if (this.toggle) {
      this.toggle.addEventListener('click', this.onToggleClick);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    if (this.scrollTopButton) {
      this.scrollTopButton.addEventListener('click', this.onScrollTopClick);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  get expanded() {
    return this.toggle.getAttribute('aria-expanded') === 'true';
  }

  set expanded(value) {
    this.toggle.setAttribute('aria-expanded', value);
    this.group.classList.toggle('lb-fab--expanded', value);
  }

  onToggleClick = () => {
    this.expanded = !this.expanded;
  };

  onDocumentClick = (event) => {
    if (this.expanded && !this.group.contains(event.target)) this.expanded = false;
  };

  onKeydown = (event) => {
    if (event.key !== 'Escape' || !this.expanded) return;
    this.expanded = false;
    this.toggle.focus();
  };

  onScrollTopClick = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };
}

customElements.define('lb-contact-fab', LbContactFab);
